var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBraboPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 62,
    viewBox: "0 0 74 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_7905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7752 17.1909V48.0309C68.7752 48.8209 68.1352 49.4709 67.3352 49.4709H17.4752C16.6852 49.4709 16.0352 48.8309 16.0352 48.0309V13.9009C16.0352 13.1109 16.6752 12.4609 17.4752 12.4609H55.5452",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.355 55.5109V49.4709",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4551 49.4709V55.5109",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3651 55.5109H31.4551",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1451 60.8709H5.04508C4.58508 60.8709 4.20508 60.5009 4.20508 60.0309V54.2309C4.20508 53.7709 4.57508 53.3909 5.04508 53.3909H24.1451C24.6051 53.3909 24.9851 53.7609 24.9851 54.2309V60.0309C24.9851 60.4909 24.6151 60.8709 24.1451 60.8709Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40527 47.4609V53.3909",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89502 45.8709C9.37502 46.2409 9.68502 46.8209 9.68502 47.4809C9.68502 48.0309 9.46502 48.5309 9.10502 48.9009",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67496 48.8209C5.30496 48.4509 5.08496 47.9509 5.08496 47.3909C5.08496 46.9109 5.25496 46.4609 5.53496 46.1109",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.605 44.4809C11.295 45.2509 11.725 46.2609 11.725 47.3809C11.725 48.4409 11.345 49.4109 10.715 50.1609",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06496 50.1209C3.45496 49.3709 3.08496 48.4209 3.08496 47.3809C3.08496 46.1909 3.56496 45.1209 4.34496 44.3409",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7251 42.6609C13.0051 43.8309 13.8051 45.5109 13.8051 47.3809C13.8051 49.2509 13.0051 50.9309 11.7251 52.1109",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67512 51.7009C1.63512 50.5609 0.995117 49.0409 0.995117 47.3809C0.995117 45.5109 1.79512 43.8209 3.07512 42.6509",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69498 57.1109C6.09498 57.1109 5.60498 56.6209 5.60498 56.0209C5.60498 55.4209 6.09498 54.8909 6.69498 54.8909C7.29498 54.8909 7.78498 55.3509 7.78498 55.9509V56.0209C7.78498 56.6209 7.29498 57.1109 6.69498 57.1109Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78531 57.1109C9.18531 57.1109 8.69531 56.6209 8.69531 56.0209C8.69531 55.4209 9.18531 54.8909 9.78531 54.8909C10.3853 54.8909 10.8753 55.3509 10.8753 55.9509V56.0209C10.8753 56.6209 10.3853 57.1109 9.78531 57.1109Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4253 57.1309H17.0853",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4653 57.1309H23.5453",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4253 57.1309H20.5053",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.425 37.9709C62.1916 37.9709 65.245 34.9175 65.245 31.1509C65.245 27.3843 62.1916 24.3309 58.425 24.3309C54.6584 24.3309 51.605 27.3843 51.605 31.1509C51.605 34.9175 54.6584 37.9709 58.425 37.9709Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4249 32.5909C59.2202 32.5909 59.8649 31.9462 59.8649 31.1509C59.8649 30.3556 59.2202 29.7109 58.4249 29.7109C57.6296 29.7109 56.9849 30.3556 56.9849 31.1509C56.9849 31.9462 57.6296 32.5909 58.4249 32.5909Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.235 26.5909H59.565L59.655 28.7509L61.665 27.8309L62.905 29.9509L61.095 31.1509L62.905 32.4009L61.475 34.4809L59.865 33.6009L59.575 35.7309L56.975 35.6609V33.5109L54.965 34.5309L53.605 32.3509L55.655 31.1609L53.725 29.9409L55.225 27.7509L57.105 28.7209L57.235 26.5909Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.755 32.5909H40.535C39.475 32.5909 38.625 31.7309 38.625 30.6809V21.1709C38.625 20.1109 39.485 19.2609 40.535 19.2609H58.255V24.3409",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.415 32.5909V19.2509",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5952 23.1009H53.7352",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5952 26.1809H53.7352",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5952 29.2509H51.8752",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.615 23.9609H36.205C35.905 23.9609 35.665 24.2009 35.665 24.5009V27.3609C35.665 27.6609 35.905 27.9009 36.205 27.9009H38.615",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2549 21.2109H60.5249C61.0749 21.2109 61.5149 21.6509 61.5149 22.2009V25.0109",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.725 10.2109C63.935 11.0009 62.635 11.0009 61.845 10.2109L59.945 8.31092C59.155 7.52092 59.155 6.22092 59.945 5.43092C60.735 4.64092 62.035 4.64092 62.825 5.43092L63.065 5.67092",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5952 8.21092C64.3852 7.42092 65.6852 7.42092 66.4752 8.21092L68.3752 10.1109C69.1652 10.9009 69.1652 12.2009 68.3752 12.9909C67.5852 13.7809 66.2852 13.7809 65.4952 12.9909L65.2252 12.7209",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2752 16.3609H19.9652C19.7387 16.3609 19.5552 16.5445 19.5552 16.7709V18.0809C19.5552 18.3074 19.7387 18.4909 19.9652 18.4909H21.2752C21.5016 18.4909 21.6852 18.3074 21.6852 18.0809V16.7709C21.6852 16.5445 21.5016 16.3609 21.2752 16.3609Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2752 20.6709H19.9652C19.7387 20.6709 19.5552 20.8545 19.5552 21.0809V22.3909C19.5552 22.6174 19.7387 22.8009 19.9652 22.8009H21.2752C21.5016 22.8009 21.6852 22.6174 21.6852 22.3909V21.0809C21.6852 20.8545 21.5016 20.6709 21.2752 20.6709Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2752 24.6409H19.9652C19.7387 24.6409 19.5552 24.8245 19.5552 25.0509V26.3609C19.5552 26.5874 19.7387 26.7709 19.9652 26.7709H21.2752C21.5016 26.7709 21.6852 26.5874 21.6852 26.3609V25.0509C21.6852 24.8245 21.5016 24.6409 21.2752 24.6409Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2752 28.6109H19.9652C19.7387 28.6109 19.5552 28.7945 19.5552 29.0209V30.3309C19.5552 30.5574 19.7387 30.7409 19.9652 30.7409H21.2752C21.5016 30.7409 21.6852 30.5574 21.6852 30.3309V29.0209C21.6852 28.7945 21.5016 28.6109 21.2752 28.6109Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2752 32.5809H19.9652C19.7387 32.5809 19.5552 32.7645 19.5552 32.9909V34.3009C19.5552 34.5274 19.7387 34.7109 19.9652 34.7109H21.2752C21.5016 34.7109 21.6852 34.5274 21.6852 34.3009V32.9909C21.6852 32.7645 21.5016 32.5809 21.2752 32.5809Z",
    fill: "#848485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2549 17.4209H32.8249",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9952 9.20592C72.9952 4.32648 69.0396 0.370915 64.1602 0.370915C59.2808 0.370915 55.3252 4.32648 55.3252 9.20592C55.3252 14.0854 59.2808 18.0409 64.1602 18.0409C69.0396 18.0409 72.9952 14.0854 72.9952 9.20592Z",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2549 34.3509V46.3009H46.1049",
    stroke: "#848485",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1147 39.1109V44.2409",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5547 36.6709V44.2409",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6748 41.1509V44.2409",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6948 38.0109V44.2409",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8647 37.2609V44.2409",
    stroke: "#848485",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_7905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.75,
    height: 61.25,
    fill: "white",
    transform: "translate(0.625 0.000915527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraboPlatform);
export default __webpack_public_path__ + "static/media/brabo-platform.c46c083bd3b2c11121966faf75b6e924.svg";
export { ForwardRef as ReactComponent };